import { OktaAuth } from "@okta/okta-auth-js";
import { oktaConfig } from "./oktaConfig";

const oktaInstance = new OktaAuth(oktaConfig);

export default oktaInstance;
